<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconLiveStreamCloud_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M3.5 17.5h14.41q.26 0 .51.006c.913.018 1.712.033 2.58-.506.637-.396 1-2.344 1-3.437q0-1.51-1.034-2.636t-2.602-1.302q0-2.56-1.853-4.342Q14.66 3.5 12 3.5q-2.16 0-3.864 1.247t-2.272 3.26q-1.728.371-2.796 1.705A4.73 4.73 0 0 0 2 12.753C2 14.08 3 17.5 3.5 17.5m11.5-6-5-3v6z"
        clip-rule="evenodd"
    />
</svg>
